// extracted by mini-css-extract-plugin
module.exports = {"kitM":"kitM_kitM__9e38t"};